import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import { useEnabledFeatures } from './useEnabledFeatures'
import { useViewOptions } from './useViewOptions'

interface Params {
  preview?: boolean
}

export const useCurrentViewOptions = ({ preview = false }: Params = {}) => {
  const [{ canUseViewOptions }] = useEnabledFeatures()
  const [{ view }] = useSchedule()
  const [{ allViewOptions }] = useViewOptions()
  const viewOptionsArgs = { canUseViewOptions: canUseViewOptions && !preview }
  const viewOptions = allViewOptions.viewOptionsFor(view, viewOptionsArgs)

  return { viewOptions }
}
